$.fn.instagramfeed = function() {
	var $me = $(this),
		instagram = $me.data('instagram');

	if(!instagram)
		return;

	var $loader = $('<div class="loader"></div>');

	$me.append($loader);
	$loader.addClass('show');

	$.ajax({
		url: 'https://www.instagram.com/' + instagram + '?__a=1',
		type: "GET",
		success: function(data){
			data = data.graphql.user;
			var imgs = data.edge_owner_to_timeline_media.edges;

			for(var i = 0; i < 8; i++) {
				var html = '<div class="col medium-3 small-6"><div class="card">' +
					'<a href="https://www.instagram.com/p/' + imgs[i].node.shortcode + '/" target="_blank" class="card_thumbnail">' +
					'<img src="' + imgs[i].node.thumbnail_resources[1].src + '" />' +
					'</a>' +
					'</div></div>';

				$loader.before(html);
			}
			$loader.removeClass('show');
		}
	});
};

$('[data-instagram]').instagramfeed();
